import { PROMO_ID } from 'reactApp/appHelpers/featuresHelpers/features/webAutoUpload';
import { getDataFromStorage, saveDataToStorage } from 'reactApp/storage';

interface FakedoorStorageInfo {
    shown?: boolean;
}

export const markFakedoorCompleted = () => {
    saveDataToStorage<FakedoorStorageInfo>(PROMO_ID, { shown: true });
};

export const isFakedoorCompleted = () => {
    const { shown } = getDataFromStorage<FakedoorStorageInfo>(PROMO_ID);
    return !!shown;
};
